// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"c0852e57","283":"91977d12","787":"0957de97","902":"f03fa759"}[chunkId] + ".chunk.js";
};